import { PifSection } from "./pif-section";
import { SubscriptionsSection } from "./SubscriptionsSection";
import { VoucherSection } from "./voucher-section";

export const OtherBlock = () => {
  return (
    <section className='flex flex-col pt-8 space-y-8'>
      <SubscriptionsSection />
      <PifSection />
      <VoucherSection />
    </section>
  );
};
